import React, { FC, useEffect } from "react"
import { useTranslation, Trans, useI18next } from "../../plugins/i18next/ea-react-i18next"
import { ArticleNode } from "../../utils/core"
import chaosnotgood from "../../pages/success-stories/posts/images/chaos-not-so-good.png"
import learnmore from "../../pages/success-stories/posts/images/learn-more.png"
import SuccessStorySideBar from "./SuccessStoriesSideBar"
import SuccessVideos from "./SuccessVideos"

const SuccessStoryDetailsContent: FC<{ successstory: ArticleNode }> = ({
  successstory,
}) => {
  const { t } = useTranslation("components", {
    keyPrefix: "successStories.successStoriesDetailsContent",
  })

  if (!successstory) {
    return <React.Fragment></React.Fragment>
  }

    const { i18n } = useI18next()
    const currentLanguage = i18n.language

  const { frontmatter, html } = successstory
  const {
    title,
    slug,
    description,
    subtitle,
    successstoryfile,
    videoId,
    videoTitle,
  } = frontmatter

  const IsVideoStory = videoId !== null && videoId !== undefined ? true : false

  
      useEffect(() => {
        if (typeof window === "undefined") return
  
        document.body.classList.remove("lang-en", "lang-de")
        document.body.classList.add(`lang-${currentLanguage}`)
      }, [])
      

  return (
    <section className="blog-details-area successstory-details-area">
      <div>
        <div className="row">
          <div className="col-lg-12 col-md-12">
            <div className="successstory-gradient">
              <div className="successstory-banner  container-fluid hero-container col-lg-12 col-md-12 ">
                <h1 className="story-title">{title}</h1>
                <h2 className="story-description">{subtitle ?? description}</h2>
              </div>
            </div>
            {IsVideoStory ? (
              <>
                <div className="container-fluid hero-container">
                  <div className="row">
                    <SuccessVideos videoId={videoId} videoTitle={videoTitle} />
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="blog-details-desc ">
                  <div className="container-fluid hero-container">
                    <div className="row">
                      <div className="col-lg-7 col-md-12 success-article-content">
                        <div dangerouslySetInnerHTML={{ __html: html }} />
                      </div>
                      <div className="col-lg-5 col-md-12 success-article-content">
                        <img
                          id="chaosnotgood"
                          src={chaosnotgood}
                          alt="Chaos not so good"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="successstory-footer col-lg-12 col-md-12">
                  <div className="row success-align-items-center container-fluid hero-container">
                    <div className="learnmore">
                      <img id="learnmore" src={learnmore} alt="Learn More" />
                    </div>
                    <div className="subscribe-content successstory col-lg-6 col-md-12">
                      <div className="success-footer-text">
                        <h1 className="footer-title">{t("learnMore")}</h1>
                        <h2 className="footer-description">
                          {t("downloadDescription")}
                        </h2>
                      </div>
                    </div>
                    <div className="subscribe-content successstory col-lg-2 col-md-12">
                      <a
                        href={successstoryfile?.publicURL}
                        className={`default-btn successstory-pdf with-icon`}
                        target="_blank"
                      >
                        <i className="flaticon-right" />
                        {<Trans t={t}>{"downloadPdf"}</Trans>}
                        <span />
                      </a>
                    </div>
                  </div>
                </div>
              </>
            )}

            <div className="col-lg-12 col-md-12">
              <SuccessStorySideBar currentSlug={slug} />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SuccessStoryDetailsContent
